var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgShareGreyThick = function SvgShareGreyThick(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8461 7.23096H14.2307C14.4143 7.23096 14.5904 7.30389 14.7202 7.43372C14.85 7.56355 14.923 7.73964 14.923 7.92325V18.3076C14.923 18.4912 14.85 18.6673 14.7202 18.7971C14.5904 18.927 14.4143 18.9999 14.2307 18.9999H1.76944C1.58583 18.9999 1.40975 18.927 1.27992 18.7971C1.15009 18.6673 1.07715 18.4912 1.07715 18.3076V7.92325C1.07715 7.73964 1.15009 7.56355 1.27992 7.43372C1.40975 7.30389 1.58583 7.23096 1.76944 7.23096H3.15402",
    stroke: "currentColor",
    strokeOpacity: 0.74,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99878 10.6921V1",
    stroke: "currentColor",
    strokeOpacity: 0.74,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23584 3.76916L8.005 1L10.7742 3.76916",
    stroke: "currentColor",
    strokeOpacity: 0.74,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgShareGreyThick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share-grey-thick.fb914e3921ea3feb1bbdcc9475ad0c22.svg";